import styled from '@emotion/styled';
import { ProfileStage, PROFILE_STAGE } from 'domain/entities/AgentUser/AgentUser';
import { useNavigate } from 'react-router-dom';
import Img01 from 'ui/images/top/topService_img01@2x.png';

const Wrapper = styled.div`
    width: 80svw;
    padding: 30px 20px;
    max-width: 600px;
    border-radius: 20px;
    background: var(--white);
    margin: 10px auto;
    text-align: center;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);

    img {
        width: 170px;
        margin: 0 auto;
    }
`;

const Title = styled.div`
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 20px;
    line-height: 1.5;
`;

const Descriptions = styled.div`
    text-align: center;
    gap: 5px;
    display: flex;
    flex-direction: column;
    margin: 10px auto;
`;

const Desc = styled.div`
    padding: 0 4px;
    font-size: var(--font-large);
    font-weight: var(--font-bold);
`;

const SubmitButton = styled.button`
    background-color: var(--primary);
    color: var(--white);
    font-size: var(--font-large);
    font-weight: var(--font-bold);
    padding: 15px 25px;
    border-radius: 25px;
    cursor: pointer;
    margin: 20px auto 0 auto;
    border: none;
    outline: none;
`;

interface Props {
    profile_step?: ProfileStage;
}

// profile_stepに対するリダイレクトURL定義
const redirectUrl = {
    [PROFILE_STAGE.ONLY_PASSWORD]: '/agent/registration/agent_profile/',
    [PROFILE_STAGE.NEED_COMPANY_INFO]: '/agent/registration/agent_profile/',
    [PROFILE_STAGE.NEED_USER_PROFILE]: '/agent/registration/user_profile/',
};

/**
 * プロフィール登録しましょうのモーダル
 */
export const NeedProfileRegistration: React.FC<Props> = ({ profile_step }) => {
    const navigate = useNavigate();
    const onClick = () => {
        if (!profile_step) return;
        if (profile_step !== PROFILE_STAGE.COMPLETE) {
            navigate(redirectUrl[profile_step]);
        }
    };
    return (
        <Wrapper>
            <Title>【サービスを利用するためにプロフィールを登録してください】</Title>
            <Descriptions>
                <img src={Img01} alt="マッチング" />
                <Desc>プロフィールを登録することで、より多くの機能を利用できます。</Desc>
            </Descriptions>
            <SubmitButton onClick={onClick}>プロフィール入力へ進む</SubmitButton>
        </Wrapper>
    );
};
